<template>
  <l-map :zoom="zoom" :center="center">
    <l-tile-layer :url="url"></l-tile-layer>
    <l-marker :lat-lng="markerLatLng"></l-marker>
  </l-map>
</template>

<script>
import {LMap, LTileLayer, LMarker} from 'vue2-leaflet';

export default {
  name: 'Map_one_point',
  components: {
    LMap,
    LTileLayer,
    LMarker
  },
  props: {
    lat: Number,
    lon: Number
  },
  data () {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 13,
      center: [this.lat, this.lon],
      markerLatLng: [this.lat, this.lon]
    };
  }
}
</script>
<style>
  .leaflet-bottom{
    visibility: hidden;
  }
</style>